export default __webpack_public_path__ + "static/media/flag-madeira.db09fe5f.svg";